import { checkApiAvailability } from '../api'
import { isAuthExpiredError } from '../authErrors'
import { canAccessProtectedNetwork } from '../authStatus'

export type SyncAllPreflightResult =
  | { ok: true }
  | { ok: false; error: string; eventMessage: 'auth required' | 'offline' }

export async function runSyncAllPreflight(): Promise<SyncAllPreflightResult> {
  if (!canAccessProtectedNetwork()) {
    return {
      ok: false,
      error: 'Sign in online to sync recordings',
      eventMessage: 'auth required',
    }
  }

  try {
    const apiAvailable = await checkApiAvailability()
    if (!apiAvailable) {
      return {
        ok: false,
        error: 'API is not available (offline or unreachable)',
        eventMessage: 'offline',
      }
    }
    return { ok: true }
  } catch (error) {
    if (isAuthExpiredError(error)) {
      return {
        ok: false,
        error: error.message,
        eventMessage: 'auth required',
      }
    }
    throw error
  }
}

export async function runImmediateSyncPreflight(): Promise<boolean> {
  if (!canAccessProtectedNetwork()) {
    console.log('Waiting for authentication + connectivity before syncing submission')
    return false
  }

  try {
    const apiAvailable = await checkApiAvailability()
    if (!apiAvailable) {
      console.log('API not available, submission saved locally only')
      return false
    }
    return true
  } catch (error) {
    if (isAuthExpiredError(error)) {
      return false
    }
    throw error
  }
}
